/**
 * Dashboard / Historical use `?cfg=<sensor_configs.id>` so the address bar does not
 * expose the device `sensor_id` string. Legacy `?sensor=<sensor_id>` is still read
 * for old bookmarks and is replaced with `cfg` when matched.
 *
 * This is not encryption: it is an opaque row id scoped by auth + RLS. Anyone who
 * can guess ids still needs a valid session and policies that allow that row.
 *
 * @param {URLSearchParams} searchParams
 * @param {Array<{ id: number, sensor_id: string }>} sensors
 */
export function resolveSensorIdFromUrl(searchParams, sensors) {
	if (!sensors?.length) {
		return { sensorId: null, configId: null }
	}

	const cfgRaw = searchParams.get('cfg')
	if (cfgRaw != null && cfgRaw !== '') {
		const row = sensors.find(s => String(s.id) === String(cfgRaw))
		if (row) return { sensorId: row.sensor_id, configId: row.id }
	}

	const legacy = searchParams.get('sensor')
	if (legacy != null && legacy !== '') {
		const row = sensors.find(s => s.sensor_id === legacy)
		if (row) return { sensorId: row.sensor_id, configId: row.id }
		return { sensorId: legacy, configId: null }
	}

	return { sensorId: null, configId: null }
}

/** @param {number | string} configId */
export function buildCfgSearchParams(configId) {
	return { cfg: String(configId) }
}

/**
 * All-scope deep link: encodes both the sensor config id and the customer id so
 * the dashboard / historical pages can identify the sensor unambiguously.
 *
 * @param {number | string} configId
 * @param {number | string} customerId
 */
export function buildAllScopeCfgSearchParams(configId, customerId) {
	return { cfg: String(configId), cust: String(customerId) }
}
